import React from "react";
import { useMediaQuery, useTheme } from "@mui/material";

const currentYear = new Date().getFullYear();

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <footer
      style={{
        backgroundColor: "#000000",
        height: "4rem",
        display: "flex",
        alignItems: "center",
        borderTop: "0.15rem #ffffff solid",
        justifyContent: isMobile ? "center" : "flex-start",
        padding: isMobile ? "0 0.25rem" : "0 0 0 2rem",
      }}
    >
      <p
        style={{
          color: "#ffffff",
          fontSize: "0.8rem",
        }}
      >
        &copy; Copyright {currentYear} Advanced Compliance Technology Ltd
      </p>
    </footer>
  );
};

export default Footer;
